import React, { useEffect, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa6';
import { useParams, useNavigate } from 'react-router-dom';

import { validateForm } from './auxiliarTeds';
import { TedPlanoAcao } from './planoAcao';
import { SubAbasTeds, SubAbasTedsNovo } from './subabasTeds';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomCol from '../../../../components/CustomCol';
import { CustomSwal } from '../../../../components/CustomFeedback/CustomSwal';
import CustomRow from '../../../../components/CustomRow';
import FiscalContratoComponente from '../../../../components/FiscalContrato';
import Input from '../../../../components/InputNew';
import Select from '../../../../components/InputNew/Select';
import SelectInput from '../../../../components/InputNew/Select';
import StyledLink from '../../../../components/Link';
import Log from '../../../../components/Log/Log';
import ParteEnvolvidaComponente from '../../../../components/ParteEnvolvida';
import ResponsavelAquisicaoComponente from '../../../../components/ResponsavelAquisicao';
import SubAbas from '../../../../components/SubAbas';
import TramitacaoComponente from '../../../../components/Tramitacao';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import { getUser } from '../../../../modules/contexts/Auth/RequireAuth';
import { useSelect } from '../../../../modules/contexts/Select/useSelect';
import { EnumOption } from '../../../../modules/types/types';
import { getAllFornecedoresSimplificado } from '../../../../services/fornecedoresDAF/fornecedorService';
import { isHttpError } from '../../../../services/httpClient';
import {
  createTed,
  deleteTed,
  getTed,
  updateTed,
} from '../../../../services/teds/tedsService';
import theme from '../../../../theme';
import {
  formataNomeMeioSiglas,
  formatDateSimp,
} from '../../../../utils/functions';
import {
  swal,
  swalAtualizacao,
  swalSave,
  swalErro,
  swalDelete,
  swalDeleteConfirm,
  swalAttention,
} from '../../../../utils/swal';
import { Fornecedor } from '../../Fornecedores/types';

export default function TedsFicha() {
  //DADOS USUARIO
  const user = getUser();
  const userID = user.sub;
  const userComponenteAFLabel =
    user?.vinculo?.[0]?.nomeInstituicao ?? 'Não informado';
  const userComponenteAF = Number(user?.vinculo?.[0]?.numeroComponenteAF ?? 0);

  //OPTIONS
  // const componenteAF = useComponentesPaf();
  const { getSelectDominioPai } = useSelect();
  const statusTedOptions = getSelectDominioPai(52);
  const componenteAFoptions = getSelectDominioPai(1);
  const fornecedorPapelOptions = getSelectDominioPai(58);

  // Gatilho para atualização do Log
  const [refreshTriggerLog, setRefreshTriggerLog] = useState(0);
  const triggerRefresh = () => setRefreshTriggerLog((prev) => prev + 1);

  //Dados do componente
  let logs = {};
  let subAbas = [];

  //PERMISSOES
  const navigate = useNavigate();
  const params = useParams();
  const fichaID = String(params.id);

  //FORMS TED
  const [logData, setLogData] = useState({
    id: '',
    usuarioRegistro: {
      nomeCompleto: '',
    },
    usuarioAtualizacao: {
      nomeCompleto: '',
    },
    dataRegistro: '',
    dataUltimaAtualizacao: '',
    dataUltimaVisualizacao: '',
    nEdicoes: '',
    nVisualizacoes: '',
    nVisualizadores: '',
  });
  const [formTed, setFormTed] = useState({
    usuarioId: userID,
    id: 0,
    status: 0,
    componenteAf: userComponenteAF,
    fornecedorId: 0,
    fornecedorPapel: 0,
    nupSeiFase1: '',
    nupSeiFase2: '',
    numeroTed: '',
    documentoSei: '',
    dataDOU: '',
    dataInicio: '',
    dataTermino: '',
    link: '',
    observacoes: '',
  });

  //FORNECEDORES
  // const fornecedorPapelOptions = usePapelFornecedor();
  const [fornecedoresOptionsData, setFornecedoresOptionsData] = useState<
    Fornecedor[]
  >([]);
  const fetchFornecedores = async () => {
    try {
      const fornecedoresSimplificado = await getAllFornecedoresSimplificado();
      setFornecedoresOptionsData(fornecedoresSimplificado);
    } catch (error: any) {
      console.log(error.response?.data.message);
    }
  };
  const fornecedorOptions: EnumOption[] = [
    { value: '0', label: 'Não informado' },
    ...fornecedoresOptionsData.map((item, index) => ({
      value: item.id?.toString() ?? index.toString(),
      label: item.razaoSocial
        ? item.cnpj + ' - ' + item.razaoSocial
        : 'Não informado',
    })),
  ];
  useEffect(() => {
    fetchFornecedores();
  }, []);
  const [cnpjSelecionado, setCnpjSelecionado] = useState<string>('');
  useEffect(() => {
    const fornecedor = fornecedoresOptionsData.find(
      (f) => f.id?.toString() === formTed.fornecedorId?.toString(),
    );
    setCnpjSelecionado(fornecedor?.cnpj || '');
  }, [formTed.fornecedorId, fornecedoresOptionsData]);

  //FETCH DATA MAIN
  const fetchData = async (id: string) => {
    try {
      const registroData = await getTed(id);
      setLogData(registroData);

      const dataDou = registroData.dataDou
        ? new Date(registroData.dataDou).toISOString().split('T')[0]
        : '';

      const dataInicio = registroData.dataInicio
        ? new Date(registroData.dataInicio).toISOString().split('T')[0]
        : '';

      const dataTermino = registroData.dataTermino
        ? new Date(registroData.dataTermino).toISOString().split('T')[0]
        : '';

      setFormTed({
        usuarioId: userID,
        id: registroData.id,
        fornecedorId: registroData.fornecedor.id,
        fornecedorPapel: registroData.fornecedorPapel,
        status: registroData.status,
        componenteAf: registroData.componenteAf,
        nupSeiFase1: registroData.nupSeiFase1,
        nupSeiFase2: registroData.nupSeiFase2,
        numeroTed: registroData.numeroTed,
        documentoSei: registroData.documentoSei,
        dataDOU: dataDou,
        dataInicio: dataInicio,
        dataTermino: dataTermino,
        link: registroData.link,
        observacoes: registroData.observacoes,
      });
      triggerRefresh(); // Dispara a atualização dos logs
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  //Condicional para verificar se é necessário buscar dados e ajustar subabas
  if (fichaID !== 'undefined') {
    //Buscar dados
    useEffect(() => {
      fetchData(fichaID);
    }, []);
    logs = {
      id: logData.id,
      usuarioRegistro: formataNomeMeioSiglas(
        logData.usuarioRegistro.nomeCompleto,
      ),
      usuarioAtualizacao: formataNomeMeioSiglas(
        logData.usuarioAtualizacao.nomeCompleto,
      ),
      dataRegistro: logData.dataRegistro,
      dataAtualizacao: logData.dataUltimaAtualizacao,
      nEdicoes: logData.nEdicoes,
    };

    //Subabas
    subAbas = SubAbasTeds(fichaID);
  } else {
    subAbas = SubAbasTedsNovo;
  }

  //HANDLE - TED
  const handleChangeTed = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = event.target;

    if (name === 'fornecedorId') {
      const selectedFornecedor = fornecedoresOptionsData.find(
        (fornecedor) => fornecedor.id === parseInt(value, 10),
      );
      if (selectedFornecedor) {
        setFormTed((prev) => ({
          ...prev,
          cnpj: selectedFornecedor.cnpj ?? '',
        }));
      }
    }

    setFormTed((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  //CRUD - TED

  const handleCreateTed = async () => {
    if (
      ['Gabinete', 'Coordenação de Fiscalização de Contratos'].includes(
        userComponenteAFLabel,
      )
    ) {
      CustomSwal.show({
        type: 'warning',
        title: 'Atenção',
        html: 'Usuários vinculados ao Gabinete ou à Coordenação de Fiscalização de Contratos não podem criar ACTs.',
        showConfirmButton: true,
      });
      return;
    }
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formTed);
      if (!isFormValid) return;

      const formToSend = {
        ...formTed,
        status: Number(formTed.status),
        fornecedorId: Number(formTed.fornecedorId),
        fornecedorPapel: Number(formTed.fornecedorPapel),
        dataDou: formTed.dataDOU ? formTed.dataDOU : null,
        dataInicio: formTed.dataInicio ? formTed.dataInicio : null,
        dataTermino: formTed.dataTermino ? formTed.dataTermino : null,
      };

      //POST
      const response = await createTed(formToSend);
      swalSave();
      setTimeout(
        () =>
          (window.location.href = `#/daf/proaq/teds/${response.data.registro.id}/dadosgerais`),
        2500,
      );
    } catch (error) {
      if (isHttpError(error)) {
        CustomSwal.show({
          type: 'error',
          title: 'Erro ao salvar registro',
          html: error.response?.data?.message,
        });
        return;
      }

      CustomSwal.show({
        type: 'error',
        title: 'Erro inesperado',
        html: 'Não foi possível concluir a operação.',
      });
    }
  };

  const handleUpdateTed = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formTed);
      if (!isFormValid) return;

      const formToSend = {
        ...formTed,
        status: Number(formTed.status),
        fornecedorId: Number(formTed.fornecedorId),
        fornecedorPapel: Number(formTed.fornecedorPapel),
        dataDou: formTed.dataDOU ? formTed.dataDOU : null,
        dataInicio: formTed.dataInicio ? formTed.dataInicio : null,
        dataTermino: formTed.dataTermino ? formTed.dataTermino : null,
      };

      const response = await updateTed(fichaID, formToSend);

      swalAtualizacao('Sucesso', response.data.message);
      fetchData(response.data.registro.id);
    } catch (error) {
      if (isHttpError(error)) {
        CustomSwal.show({
          type: 'error',
          title: 'Erro ao salvar registro',
          html: error.response?.data?.message,
        });
        return;
      }

      CustomSwal.show({
        type: 'error',
        title: 'Erro inesperado',
        html: 'Não foi possível concluir a operação.',
      });
    }
  };

  const handleDeleteTed = async () => {
    const result = await swalDelete();
    if (!result) {
      return;
    }

    if (result) {
      try {
        await deleteTed(fichaID);
        swalDeleteConfirm();
        navigate('/daf/proaq/teds');
      } catch (error: any) {
        swalErro(error.response?.data.message);

        console.error('Erro ao excluir registro', error);
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
    } else {
      swalErro('A operação falhou.');
    }
  };

  //USE EFFECT
  useEffect(() => {
    const { dataDOU, dataInicio } = formTed;

    if (dataDOU && dataInicio) {
      const dtDou = new Date(dataDOU);
      const dtTermino = new Date(dataInicio);

      if (dtTermino < dtDou) {
        setFormTed((prev) => ({
          ...prev,
          dataInicio: '',
        }));
        swalAttention(
          `A data de <b>INÍCIO</b> ${formatDateSimp(dataInicio)} <b><span style="color:red">não pode ser anterior</span></b> à data de <b>DOU</b> ${formatDateSimp(dataDOU)}.`,
        );
      }
    }
  }, [formTed.dataDOU, formTed.dataInicio]);

  useEffect(() => {
    const { dataInicio, dataTermino } = formTed;

    if (dataInicio && dataTermino) {
      const dtInicio = new Date(dataInicio);
      const dtTermino = new Date(dataTermino);

      if (dtTermino < dtInicio) {
        setFormTed((prev) => ({
          ...prev,
          dataTermino: '',
        }));
        swalAttention(
          `A data de <b>TÉRMINO</b> ${formatDateSimp(dataTermino)} <b><span style="color:red">não pode ser anterior</span></b> à data de <b>INÍCIO</b> ${formatDateSimp(dataInicio)}.`,
        );
      }
    }
  }, [formTed.dataInicio, formTed.dataTermino]);

  const [diasFimTed, setDiasFimTed] = useState(0);
  useEffect(() => {
    const { dataTermino } = formTed;

    if (!dataTermino) {
      setDiasFimTed(0);
      return;
    }

    const hoje = new Date();
    const termino = new Date(dataTermino);

    // Zera a hora para comparar apenas as datas
    hoje.setHours(0, 0, 0, 0);
    termino.setHours(0, 0, 0, 0);

    const diffMs = termino.getTime() - hoje.getTime();
    const diffDias = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

    setDiasFimTed(diffDias > 0 ? diffDias : 0);
  }, [formTed.dataTermino]);

  const [statusTedStyle, setStatusTedStyle] = useState<React.CSSProperties>({});
  useEffect(() => {
    const emElaboracao = theme.colors.amarelogov;
    const emExecucao = theme.colors.verdegov;
    const finalizado = theme.colors.cinzaEscuro;
    const suspenso = theme.colors.statusTed.suspenso;
    const cancelado = theme.colors.statusTed.cancelado;

    const status = Number(formTed.status);

    const newStatusStyle = {
      backgroundColor:
        status === 1
          ? emElaboracao
          : status === 2
            ? emExecucao
            : status === 3
              ? finalizado
              : status === 4
                ? suspenso
                : status === 5
                  ? cancelado
                  : 'white',
      color: status === 0 ? 'black' : 'white',
    };
    setStatusTedStyle(newStatusStyle);
  }, [formTed.status]);

  const [isDataActive, setIsDataActive] = useState(false);
  useEffect(() => {
    if (Number(formTed.status) > 53) {
      setIsDataActive(true);
    } else {
      setIsDataActive(false);
    }
  }, [formTed.status]);
  // alert(fichaID);

  //Retorno
  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/proaq/teds"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <WorkspaceFicha>
          {fichaID !== 'undefined' && (
            <Log
              {...logs}
              entity="TB_TED"
              id={Number(fichaID)}
              refreshTriggerLog={refreshTriggerLog}
            />
          )}

          {/* Identificação do TED */}
          <BoxConteudo boxTitulo="Identificação do TED">
            {/* Dados básicos */}
            <CustomRow>
              <CustomCol width="220px">
                <Select
                  name="status"
                  value={formTed.status}
                  options={statusTedOptions}
                  onChange={handleChangeTed}
                  label="Status"
                  // style={statusTedStyle}
                  required
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  id="componenteAF"
                  name="componenteAF"
                  value={
                    componenteAFoptions.find(
                      (comp) => comp.value === Number(formTed.componenteAf),
                    )?.label ?? ''
                  }
                  label="Componente AF"
                  onChange={handleChangeTed}
                  readonly
                />
              </CustomCol>

              <CustomCol width="250px">
                <Input
                  id="nupSeiFase1"
                  name="nupSeiFase1"
                  value={formTed.nupSeiFase1}
                  label="Nº Processo Sei - Fase 1"
                  mascara="99999.999999/9999-99"
                  onChange={handleChangeTed}
                  required
                />
              </CustomCol>
              <CustomCol width="250px">
                <Input
                  id="nupSeiFase2"
                  name="nupSeiFase2"
                  value={formTed.nupSeiFase2}
                  label="Nº Processo Sei - Fase 2"
                  mascara="99999.999999/9999-99"
                  onChange={handleChangeTed}
                  required
                />
              </CustomCol>

              <CustomCol>
                <Input
                  id="numeroTed"
                  name="numeroTed"
                  value={formTed.numeroTed}
                  label="Nº do TED"
                  onChange={handleChangeTed}
                  required
                />
              </CustomCol>
              <CustomCol>
                <Input
                  id="documentoSei"
                  name="documentoSei"
                  value={formTed.documentoSei}
                  label="Documento SEI do TED"
                  onChange={handleChangeTed}
                  required
                />
              </CustomCol>
              <CustomCol></CustomCol>
            </CustomRow>

            {/* Datas e link */}
            <CustomRow>
              <CustomCol
                width="220px"
                helpText="Data de Publicação no Diário Oficial da União"
              >
                <Input
                  id="dataDOU"
                  name="dataDOU"
                  label="Data pub. DOU"
                  value={formTed.dataDOU}
                  onChange={handleChangeTed}
                  type="date"
                  required={isDataActive}
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  id="dataInicio"
                  name="dataInicio"
                  label="Vigência - Início"
                  value={formTed.dataInicio}
                  onChange={handleChangeTed}
                  type="date"
                  required={isDataActive}
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  id="dataTermino"
                  name="dataTermino"
                  label="Vigência - Término"
                  value={formTed.dataTermino}
                  onChange={handleChangeTed}
                  type="date"
                  required={isDataActive}
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  id="diasTermino"
                  name="diasTermino"
                  label="Dias para fim da vigência"
                  value={diasFimTed}
                  style={{ textAlign: 'right' }}
                  onChange={handleChangeTed}
                />
              </CustomCol>
              <CustomCol>
                <Input
                  id="link"
                  name="link"
                  value={formTed.link}
                  label="Link do Documento TED"
                  onChange={handleChangeTed}
                />
              </CustomCol>
            </CustomRow>

            {/* Fornecedor */}
            <CustomRow>
              <CustomCol width="220px">
                <Input
                  id="cnpj"
                  name="cnpj"
                  label="CNPJ"
                  value={cnpjSelecionado}
                  // eslint-disable-next-line @typescript-eslint/no-empty-function
                  onChange={() => {}}
                  readonly
                />
              </CustomCol>
              <CustomCol>
                <SelectInput
                  name="fornecedorId"
                  value={formTed.fornecedorId}
                  options={fornecedorOptions}
                  onChange={handleChangeTed}
                  label="Fornecedor"
                  disabled={formTed.id === 0 ? false : true}
                  required
                />
              </CustomCol>
              <CustomCol width="250px">
                <SelectInput
                  name="fornecedorPapel"
                  value={formTed.fornecedorPapel}
                  options={fornecedorPapelOptions}
                  onChange={handleChangeTed}
                  label="Papel do Fornecedor"
                  disabled={formTed.id === 0 ? false : true}
                  required
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          {fichaID !== 'undefined' && (
            <>
              {/* Plano de Ação */}
              <TedPlanoAcao
                id_ted={Number(fichaID)}
                componente={formTed.componenteAf.toString()}
              ></TedPlanoAcao>

              {/* Seção Partes Envolvidas */}
              <ParteEnvolvidaComponente tab="ted" id_tab={fichaID} />

              {/* Seção Fiscal do Contrato */}
              <FiscalContratoComponente tab="ted" id_tab={fichaID} />

              {/* Seção Responsáveis da Aquisição */}
              <ResponsavelAquisicaoComponente tab="ted" id_tab={fichaID} />

              {/* Seção Termo Aditivo */}
              {/* <TermoAditivoComponente tab="ted" id_tab={fichaID} /> */}

              {/* Seção Tramitação SEI */}
              <TramitacaoComponente tab="ted" id_tab={fichaID} />
            </>
          )}

          {/* Seção Observações */}
          <BoxConteudo boxTitulo="Observações Gerais" fechado={true}>
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol>
                <Input
                  id="observacoes"
                  type="textarea"
                  name="observacoes"
                  linhas={5}
                  value={formTed.observacoes}
                  onChange={handleChangeTed}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>
        </WorkspaceFicha>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        {fichaID !== 'undefined' ? (
          <WorkspaceBotoes
            delete
            onClickDelete={handleDeleteTed}
            save
            onClickSave={handleUpdateTed}
          />
        ) : (
          <WorkspaceBotoes save onClickSave={handleCreateTed} />
        )}
      </BarraInferiorBotoes>
    </>
  );
}
